<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" v-for="(link, i) in links" :key="i">
        <router-link :to="link.url">{{ link.title }}</router-link>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    links: {
      type: Array,
      default: () => [],
      required: true
    }
  }
};
</script>

<style scoped></style>
